import React from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

function ItemsPerPageSelector({ items, currentSelection, onSelect, isOpen, toggle }) {

    return (
        <Dropdown isOpen={isOpen} toggle={toggle} className="ml-auto">
            <span className="mr-2">Show</span>
            <DropdownToggle caret data-testid="drop_down">{currentSelection}</DropdownToggle>
            <span className="ml-2">per page</span>
            <DropdownMenu>
                {items.map((number) => (
                    <DropdownItem key={number} onClick={() => onSelect(number)}>
                        {number}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );

}

export default ItemsPerPageSelector;